import { combineReducers } from 'redux'

import usersReduers from './users'
import companyReduers from './company'
import guidanceReducer from './guidance'

const Stores = combineReducers({
  users: usersReduers,
  companyInfo: companyReduers,
  visible: guidanceReducer
})
export default Stores
